export default {
  pagesHomeTitle: 'Xin chào',
  minUserInfo: {
    name1: 'ảnh đại diện',
    name2: 'tài khoản',
    name3: 'tên thật',
    name4: 'Tên hiển thị',
    message1: 'ảnh đại diện của người dùng chỉ có thể tải lên  jpg / png / gif',
    message2: 'Thay đổi thông tin người dùng thành công'
  },
  topComponent: {
    message: 'Nhập nội dung tìm kiếm',
    message1: 'Thay đổi mật khẩu thành công, vui lòng đăng nhập lại',
    tips: 'Chắc chắn muốn đăng xuất chứ',
    tips1: 'Tôi có cần xóa bộ nhớ cache không?',
    title1: 'đổi mật khẩu',
    title2: 'Mật khẩu cũ',
    title3: 'Mật khẩu mới',
    title4: 'Xác nhận mật khẩu',
    title5: 'thông tin cơ bản',
    title6: 'đăng xuất',
    title7: 'xóa bộ nhớ cache',
    error1: 'mật khẩu màn hình khóa',
    error2: 'Vui lòng nhập 16-32 chữ cái hoặc số',
    error3: 'Mật khẩu được nhập hai lần không khớp!',
    btn1: 'đóng những tab khác',
    btn2: 'đóng tất cả',
    btn3: 'nhiều hơn'
  },
  navComponent: {
    title: 'Quản lí hệ thống',
  },
  pagesHome: {
    select1: 'Tất cả nhà cái',
    select2: 'xếp hạng',
    title1: 'thông báo nhà cái',
    title2: 'trò chơi',
    title3: 'Số lượng đơn cược',
    title4: 'số tiền nhận',
    title5: 'tất cả',
    title6: 'Số lần đặt cược',
    title7: 'Số lần đặt cược tích lũy',
    title8: 'số tiền',
    title9: 'Số người',
    title10: 'Phân bổ đơn cược trò chơi',
    title11: 'Thời gian',
    title12: 'Tiêu đề',
    title13: 'Nội dung',
    title14: 'Hoạt động',
    title15: 'Số tiền thắng thua',
    title16: 'Số người đặt cược',
    title17: 'Số tiền cược vào',
    title18: 'Số người trúng thưởng',
    title19: 'Số tiền cược vào thực tế',
    title20: 'Dữ liệu nhà cái hôm nay được tải mới mỗi 5 phút',
    title21: '总奖金抽水',
    title22: '活动抽水',
    title23: '访问游戏人数',
    title24: '新增注册人数',
    btn1: 'Chi tiết',
    btn2: 'nhiều hơn',
    placeholder1: 'vui lòng chọn',
    tips1: 'Doanh số nhà cái= tổng cược hợp lệ - tiền thưởng + chiết khấu tiền thưởng - hoa hồng - tiền hoàn lại - tiền hoàn trả',
    tips2: 'Dữ liệu thực tiền cược hôm nay và tiền cược hiện tại (Số tiền cược- số tiền hoàn)',
    tips3: 'Chiết khấu tiền thưởng = Số tiền thưởng x chiết khấu tiền thưởng của trò chơi',
    tips4: 'Số người cược hôm nay/Thống kê số liệu thực số người trúng thưởng',
    tips5: 'Số liệu thống kê số lượng đơn cược thời gian thực hôm nay，订单平均投注金额=今日投注金额 / 今日订单数量',
    tips6: 'Số liệu thực tiền thưởng hôm nay',
    tips7: 'Hoàn trả = tổng tiền cược x (tỉ lệ hoàn của nhà cái - tỉ lệ hoàn của người chơi), nếu tỉ lệ hoàn của nhà cái lớn hơn tỉ lệ hoàn của trò chơi, thì dùng tỉ lệ hoàn của trò chơi',
    tips8: 'Hoàn lại= tồng tiền cược x tỉ lệ hoàn của người chơi, nếu tỉ lệ hoàn của người chơi lớn hơn tỉ lệ hoàn của trò chơi, thì dùng tỉ lệ hoàn của trò chơi',
    tips9: 'Số lượng người chơi đăng nhập game thời gian thực hôm nay thống kê số người truy cập game hôm nay',
    date1: 'hôm nay',
    date2: 'hôm qua',
    date3: '7 ngày gần đây',
    date4: '30 ngày gần đây',
  }
}
